const AuthReducer = (state, action) => {
  switch (action.type) {
    case "setUser":
      return { ...state, user: action.payload };
    case "setMobile":
      return { ...state, mobile: action.payload };
    case "setEmail":
      return { ...state, email: action.payload };
    case "setAddress":
      {

        const updatedAddress = Array.isArray(action.payload) ? action.payload : [action.payload];

        const oldAddress = [...state.address];

        updatedAddress.forEach(single => {
          const index = oldAddress.findIndex(item => item.id === single.id);
          if (index >= 0) {
            oldAddress[index] = single; // update
          } else {
            oldAddress.push(single); // add
          }
        });

        return {
          ...state,
          address: oldAddress
        };
      }
    case "replaceAddress":
      return {
        ...state,
        address: Array.isArray(action.payload) ? action.payload : [],
      };
    case "removeAddress":
      return {
        ...state,
        address: state.address.filter((address) => address.id !== action.payload),
      };
    default:
      return state;
  }
};
export { AuthReducer };
